export var webTheme = {
    boxShadow: {
        level1: '0px 4px 20px rgba(0, 0, 0, 0.05);',
        level2: '0px 4px 20px rgba(0, 0, 0, 0.15);',
        level3: '0px 4px 20px rgba(0, 0, 0, 0.25);',
        level4: '0px 10px 30px rgba(0, 0, 0, 0.32);',
    },
    fontFamily: "'Poppins', sans-serif",
    fontWeight: {
        thin: 100,
        extraLight: 200,
        light: 300,
        regular: 400,
        normal: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
        extraBold: 800,
        black: 900,
    },
    lineHeight: {
        default: '100%',
        sm: '115%',
        md: '125%',
        lg: '150%',
        xl: '170%',
        xxl: '200%',
    },
};
